var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDisconnectCustomer = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16.501,
    viewBox: "0 0 18 16.501",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39828",
    "data-name": "Group 39828",
    transform: "translate(-108.466 -26.747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14695",
    "data-name": "Group 14695"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23566",
    "data-name": "Path 23566",
    d: "M116.323,41.119l-.007-.012H110.4a.5.5,0,0,1-.5-.5V39.482a2.319,2.319,0,0,1,.784-1.741,8.435,8.435,0,0,1,5.179-1.778c.112,0,.223,0,.335.007h.016v-.012a5.967,5.967,0,0,1,.969-1.492l.051-.058-.074.02a3.135,3.135,0,0,1-3.983-3.06,3.177,3.177,0,1,1,5.9,1.621l-.039.065.069-.033a5.874,5.874,0,0,1,1.689-.512h.015v-.015a4.392,4.392,0,0,0,.163-1.128,4.616,4.616,0,0,0-4.6-4.619h-.006a4.61,4.61,0,0,0-2.983,8.128,8.475,8.475,0,0,0-3.634,1.792,3.742,3.742,0,0,0-1.271,2.809V40.6a1.936,1.936,0,0,0,1.925,1.932h6.925l-.037-.039A5.942,5.942,0,0,1,116.323,41.119Z",
    fill: "#95A1B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23568",
    "data-name": "Path 23568",
    d: "M121.655,33.607h-.011a4.821,4.821,0,1,0-.008,9.641h.011a4.821,4.821,0,0,0,4.819-4.811v-.011A4.833,4.833,0,0,0,121.655,33.607Zm3.489,4.819a3.483,3.483,0,1,1-3.484-3.484h0A3.5,3.5,0,0,1,125.144,38.426Z",
    fill: "#95A1B2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_64779",
    "data-name": "Path 64779",
    d: "M120.676,38.425l-1.314,1.314.985.985,1.314-1.314,1.314,1.314.985-.985-1.314-1.314,1.313-1.313-.985-.985L121.66,37.44l-1.313-1.313-.985.985Z",
    fill: "#95A1B2"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDisconnectCustomer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/disconnect-customer.818807bd.svg";
export { ForwardRef as ReactComponent };